module.exports = __webpack_public_path__ + "static/media/tomlo.683441c2.jpg";